import { NgModule, ModuleWithProviders } from '@angular/core';
import { TranslateModule, MissingTranslationHandler } from '@ngx-translate/core';
import { MyMissingTranslationHandler } from './missing-translation.handler';

@NgModule({
  imports: [TranslateModule],
  exports: [TranslateModule],
})

export class TranslationModule {
  static forRoot(): ModuleWithProviders<TranslationModule> {
    return {
      ngModule: TranslationModule,
      providers: [
        {
          provide: MissingTranslationHandler,
          useClass: MyMissingTranslationHandler,
        },
      ],
    };
  }
}
